/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Button, Input, Rate, Space } from 'antd';
import { useAppDispatch, useReviewRequestState } from '@core/configureStore';
import { openRequestEmail, respondRequest } from '@core/features/review-request/thunks';
import { useParams } from 'react-router';
import { useHeroApiService } from '@core/hooks';
import { LocalLocation, ReviewRequest, ReviewRequestStatus } from '@core/models';
import LoadableContainer from '@components/LoadableContainer';
import SplashScreen from '@components/SplashScreen';
import { formatUtcDate } from '@utils/date.util';
import { CheckCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import { NEGATIVE_RATE_CEILING } from '@constants/rate-conversion';
import { BRAND_NAME, BRAND_URL } from '@constants/brand';

type Props = {};

const RequestCallbackScreen = (props: Props) => {
  const dispatch = useAppDispatch();
  const heroApiService = useHeroApiService();
  const { isLoading } = useReviewRequestState();
  const [selectedRate, setSelectedRate] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [location, setLocation] = useState<LocalLocation | null>(null);
  const [reviewRequest, setReviewRequest] = useState<ReviewRequest | null>(null);
  const [isFetchingRequest, setIsFetchingRequest] = useState<boolean>(true);
  const [isFetchingLocation, setIsFetchingLocation] = useState<boolean>(true);
  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const [locationId, setLocationId] = useState<string | null>(null);
  const { requestId } = useParams<{ requestId: string }>();
  const [placeId, setPlaceId] = useState('');

  const submitNegativeFeedback = async () => {
    if (!requestId) return;
    await dispatch(
      respondRequest({
        requestId: parseInt(requestId),
        rate: selectedRate,
        feedback,
      })
    );
    // window.close();
    setIsSubmit(true);
  };

  const continueGoogleReview = async () => {
    if (!requestId || !placeId) return;
    await dispatch(
      respondRequest({
        requestId: parseInt(requestId),
        rate: selectedRate,
        feedback,
      })
    );
    window.location.replace(`https://search.google.com/local/writereview?placeid=${placeId}`);
  };

  useEffect(() => {
    const loadRequest = async () => {
      setIsFetchingRequest(true);
      if (!requestId) return;

      try {
        const res = await heroApiService.getReviewRequestById(parseInt(requestId));
        setReviewRequest(res);
        setLocationId(res.location_id);
      } catch (error) {
        console.log(error);
      }
      setIsFetchingRequest(false);
    };
    loadRequest();
  }, [requestId]);

  useEffect(() => {
    const initLocation = async () => {
      setIsFetchingLocation(true);
      if (locationId) {
        const res = await heroApiService.getLocationById(locationId);
        if (res && res.place_id) {
          setPlaceId(res.place_id);
        } else {
          const placeId = await heroApiService.getLocationPlaceId(locationId);
          setPlaceId(placeId);
        }
        setLocation(res);
        setIsFetchingLocation(false);
      }
    };
    initLocation();
  }, [locationId]);

  useEffect(() => {
    if (locationId && requestId) {
      dispatch(
        openRequestEmail({
          requestId: parseInt(requestId),
        })
      );
    }
  }, [locationId, requestId]);

  return (
    <div style={{ display: 'flex', height: '100vh', justifyContent: 'center' }}>
      <LoadableContainer isLoading={isFetchingRequest} loadComponent={<SplashScreen />}>
        <Space direction="vertical" style={{ justifyContent: 'center' }}>
          {reviewRequest?.stage === ReviewRequestStatus.Reviewed ? (
            <div>
              Request is already completed at {formatUtcDate(reviewRequest.last_modified_date)}
            </div>
          ) : (
            <React.Fragment>
              <LoadableContainer
                isLoading={isFetchingLocation}
                loadComponent={
                  <div style={{ textAlign: 'center', fontSize: 30 }}>
                    <LoadingOutlined />
                  </div>
                }>
                <React.Fragment>
                  <div style={{ textAlign: 'center' }}>
                    <h2>Review request from</h2>
                    <span style={{ fontSize: 30 }}>{location?.title}</span>

                    {!isSubmit ? (
                      <React.Fragment>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                          <Rate
                            style={{ fontSize: 40 }}
                            onChange={setSelectedRate}
                            value={selectedRate}
                          />
                        </div>
                        <Space
                          direction="vertical"
                          style={{ justifyContent: 'center', marginTop: 30 }}>
                          {selectedRate <= NEGATIVE_RATE_CEILING ? (
                            <React.Fragment>
                              <Input.TextArea
                                contentEditable={true}
                                value={feedback}
                                onChange={e => setFeedback(e.target.value)}
                                autoSize
                                placeholder="Enter your feedback (Optional)"
                              />
                              <Button
                                loading={isLoading}
                                disabled={selectedRate === 0}
                                onClick={submitNegativeFeedback}
                                type={'primary'}
                                style={{ width: 250 }}>
                                Submit review
                              </Button>
                            </React.Fragment>
                          ) : (
                            <Button
                              loading={isLoading}
                              onClick={continueGoogleReview}
                              type={'primary'}
                              style={{ width: 250 }}>
                              Continue
                            </Button>
                          )}
                          <a
                            href={BRAND_URL}
                            style={{ color: '#1677ff' }}
                            target="_blank"
                            rel="noreferrer">
                            powered by {BRAND_NAME}
                          </a>
                        </Space>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <div>
                          Thank you for your time. Your response has been recorded successfully
                          <CheckCircleOutlined size={80} />
                        </div>
                      </React.Fragment>
                    )}
                  </div>
                </React.Fragment>
              </LoadableContainer>
            </React.Fragment>
          )}
        </Space>
      </LoadableContainer>
    </div>
  );
};

export default RequestCallbackScreen;
